import { FC, createContext, useContext, useState } from "react";

interface ErrorProviderProps {
  children: React.ReactNode;
}

export const ErrorContext = createContext({
  isError: "",
  isVisible: true, // Add this line
  setIsError: (_value: any) => {},
  toggleVisibility: () => {}, // Add this line
});

const ErrorProvider: FC<ErrorProviderProps> = ({ children }) => {
  const [isError, setIsError] = useState('');
  const [isVisible, setIsVisible] = useState(true); // Add this line

  const toggleVisibility = () => {
    // Add this function
    setIsVisible(!isVisible);
  };
  return (
    <ErrorContext.Provider
      value={{ isError, setIsError, isVisible, toggleVisibility }}
    >
      {children}
    </ErrorContext.Provider>
  );
};

export function useError() {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error("useLoading must be used within LoadingProvider");
  }
  return context;
}

export default ErrorProvider;
